module.exports = {"pathContext":{"slug":"/404/","langKey":"en"}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/404-html.json
// module id = 683
// module chunks = 178698757827068